import templateUrl from "emun.invoice/credit-request/credit-request-line-details.htm";
import directive from "emun.invoice/credit-request/credit-request-line.directive";

export default directive(templateUrl);

